import { ICodeBookEntry } from '@src/model/common/CodeBookEntry';

export interface ICourseContentType extends ICodeBookEntry<CourseContentTypeEnum> {
}

export enum CourseContentTypeEnum {
  LECTURE = '1',
  SCORM = '2',
}
